import { FieldPath } from '../../models/FieldPath.model';

export function toFieldPath(path: string): FieldPath {
    return path as FieldPath;
}
